import React from 'react';
import styled from 'styled-components';
import Headings from '../../../atoms/Headings';

type Props = {
  headerLabel: string;
  headerValue: string | number;
  cardRows?: {
    label: string;
    value: string | number;
  }[];
};

const Card = styled.div`
  border: 1.5px solid #e8e8e8;
  border-radius: 3px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0.75rem;
  background-color: white;
`;

const HeaderLabel = styled.div`
  font-size: 18px;
`;

const CardRowWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const CardRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

const CardRowText = styled.div<{ bold?: boolean }>`
  font-size: 14px;
  ${({ bold }) => bold && `font-weight: bold;`}
`;

const DashboardCard = ({ headerLabel, headerValue, cardRows }: Props) => {
  return (
    <Card>
      <HeaderLabel>{headerLabel}</HeaderLabel>
      <Headings.h4>{headerValue}</Headings.h4>
      {!!cardRows && (
        <CardRowWrapper>
          {cardRows?.map((row) => (
            <CardRow>
              <CardRowText>{row.label}</CardRowText>
              <CardRowText bold>{row.value}</CardRowText>
            </CardRow>
          ))}
        </CardRowWrapper>
      )}
    </Card>
  );
};

export default DashboardCard;
